<template>
  <div class="bg-FFFFFF p-44-0">
    <div class="fb fb-cross-center">
      <div
        class="item-flex-1 fb fb-cross-center font-24 c-171A1D h-30 lh-30 text-center"
        v-for="(item, index) in lineList"
        :key="index"
        v-show="index < lineLength"
      >
        <div class="bg-go-down item-flex-1 bd-radio-2 relative"
          >上学
          <span
            class="absolute bg-006AFE line-bottom"
            :class="{ 'bd-l-2': index === 0 }"
          ></span>
          <span class="absolute line-circle" v-show="index > 0"></span>
          <div
            v-show="item.schoolTime"
            class="absolute font-24 c-171A1D-40 w-32 text-center h-24 text-center line-time"
            >{{ item.schoolTime }}
            <span class="absolute bl-767676 line-timeline"></span>
          </div>
        </div>
        <div class="bg-late item-flex-1 bd-radio-2 relative"
          >迟到
          <span class="absolute bg-FF9D16 line-bottom"></span>
          <div
            v-show="item.homeTime"
            class="absolute font-24 c-171A1D-40 w-32 text-center h-24 lh-16 text-center line-time-late"
            >{{ item.homeTime }}
            <span class="absolute bl-767676 line-timeline-late"></span>
          </div>
        </div>
        <div class="bg-go-down item-flex-1 bd-radio-2 relative"
          >下学<span
            class="absolute bg-006AFE line-bottom"
            :class="{ 'bd-r-2': index === lineLength - 1 }"
          ></span
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    list: {
      type: Array,
      default: () => []
    },
    length: {
      type: [Number, String],
      default: 1
    }
  },
  data() {
    return {
      lineLength: this.length,
      lineList: this.list
    }
  },
  computed: {},
  watch: {
    length(l) {
      this.lineLength = l
    },
    list(v) {
      this.lineList = v
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.bg-late {
  background: rgba(255, 157, 22, 0.2);
}
.bg-go-down {
  background: rgba(0, 137, 255, 0.2);
}
.line-bottom {
  width: 100%;
  height: 4px;
  bottom: -8px;
  left: 0;
}
.line-circle {
  width: 8px;
  height: 8px;
  border: 2px solid #18bf85;
  background: #dff6ee;
  border-radius: 4px;
  bottom: -10px;
  left: -4px;
  z-index: 99;
}
.line-time {
  bottom: -32px;
  right: -16px;
}
.line-timeline {
  top: 0;
  width: 1px;
  height: 7px;
  left: 50%;
  margin-left: -0.5px;
  border-radius: 1px;
}
.line-time-late {
  top: -24px;
  right: -16px;
}
.line-timeline-late {
  bottom: 0;
  width: 1px;
  height: 7px;
  left: 50%;
  margin-left: -0.5px;
  border-radius: 1px;
}
.bd-l-2 {
  border-radius: 2px 0 0 2px;
}
.bd-r-2 {
  border-radius: 0 2px 2px 0;
}
.bl-767676 {
  border-left: 1px solid #767676;
}
[data-dpr='2'] .bl-767676 {
  border-left: 2px solid #767676;
}
[data-dpr='3'] .bl-767676 {
  border-left: 3px solid #767676;
}
</style>
